import React from 'react';
import { 
  GitBranchPlus, 
  Database, 
  BrainCircuit, 
  Code2, 
  Bot,
  FileText,
  Zap,
  Globe,
  Mail,
  MessageSquare,
  Calendar,
  Users,
  Image,
  Workflow
} from 'lucide-react';

export type IconType = 
  | 'flow-start'
  | 'flow-dispatch' 
  | 'flow-output'
  | 'text-join'
  | 'data-mapper'
  | 'llm'
  | 'image-generation'
  | 'gmail'
  | 'google-sheets'
  | 'google-drive'
  | 'http-request'
  | 'github'
  | 'slack'
  | 'discord'
  | 'twitter'
  | 'linkedin'
  | 'notion'
  | 'airtable'
  | 'zapier'
  | 'default';

export function getIconForType(iconType: IconType): React.ReactNode {
  switch (iconType) {
    case 'flow-start':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-violet-100">
          <Workflow className="h-4 w-4 text-violet-600" />
        </div>
      );

    case 'flow-dispatch':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-violet-100">
          <GitBranchPlus className="h-4 w-4 text-violet-600" />
        </div>
      );

    case 'flow-output':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-violet-100">
          <FileText className="h-4 w-4 text-violet-600" />
        </div>
      );

    case 'text-join':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-sky-100">
          <FileText className="h-4 w-4 text-sky-600" />
        </div>
      );

    case 'data-mapper':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-sky-100">
          <Database className="h-4 w-4 text-sky-600" />
        </div>
      );

    case 'llm':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-rose-100">
          <BrainCircuit className="h-4 w-4 text-rose-600" />
        </div>
      );

    case 'image-generation':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-amber-100">
          <Image className="h-4 w-4 text-amber-600" />
        </div>
      );

    case 'gmail':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-red-100">
          <Mail className="h-4 w-4 text-red-600" />
        </div>
      );

    case 'google-sheets':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-green-100">
          <FileText className="h-4 w-4 text-green-600" />
        </div>
      );

    case 'google-drive':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-yellow-100">
          <FileText className="h-4 w-4 text-yellow-600" />
        </div>
      );

    case 'http-request':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-slate-800">
          <Code2 className="h-4 w-4 text-slate-300" />
        </div>
      );

    case 'github':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-gray-800">
          <svg className="h-4 w-4 text-white" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
          </svg>
        </div>
      );

    case 'slack':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-purple-100">
          <MessageSquare className="h-4 w-4 text-purple-600" />
        </div>
      );

    case 'discord':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-indigo-100">
          <MessageSquare className="h-4 w-4 text-indigo-600" />
        </div>
      );

    case 'twitter':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-sky-100">
          <MessageSquare className="h-4 w-4 text-sky-600" />
        </div>
      );

    case 'linkedin':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-blue-100">
          <Users className="h-4 w-4 text-blue-600" />
        </div>
      );

    case 'notion':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-gray-100">
          <FileText className="h-4 w-4 text-gray-600" />
        </div>
      );

    case 'airtable':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-orange-100">
          <Database className="h-4 w-4 text-orange-600" />
        </div>
      );

    case 'zapier':
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-orange-100">
          <Zap className="h-4 w-4 text-orange-600" />
        </div>
      );

    default:
      return (
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-purple-100">
          <div className="text-sm">🔌</div>
        </div>
      );
  }
}

// Helper function for larger icons (like in detail pages)
export function getLargeIconForType(iconType: IconType): React.ReactNode {
  switch (iconType) {
    case 'github':
      return (
        <div className="w-16 h-16 rounded-xl flex items-center justify-center bg-gray-800">
          <svg className="h-8 w-8 text-white" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
          </svg>
        </div>
      );
    case 'gmail':
      return (
        <div className="w-16 h-16 rounded-xl flex items-center justify-center bg-red-100">
          <Mail className="h-8 w-8 text-red-600" />
        </div>
      );
    case 'llm':
      return (
        <div className="w-16 h-16 rounded-xl flex items-center justify-center bg-rose-100">
          <BrainCircuit className="h-8 w-8 text-rose-600" />
        </div>
      );
    default:
      const smallIcon = getIconForType(iconType);
      // Scale up the small icon by changing classes
      if (React.isValidElement(smallIcon)) {
        return React.cloneElement(smallIcon as React.ReactElement<any>, {
          className: (smallIcon.props as any).className?.replace('w-8 h-8', 'w-16 h-16')?.replace('h-4 w-4', 'h-8 w-8')
        });
      }
      return (
        <div className="w-16 h-16 rounded-xl flex items-center justify-center bg-purple-100">
          <div className="text-2xl">🔌</div>
        </div>
      );
  }
}